<script setup>
import i18n from "@/i18n"
import {
    onMounted, ref,
    // watch
} from "vue"
import TableCom from "./components/Table"
import DetailCom from "./detail"
import {
    getFileUrl, getProductTemplateMenu,
    // database_template_name_v3,
    getHscode
} from "@/service/index"
// import { id } from "element-plus/es/locale/index.mjs"
// import { getParentTree } from "@/utils/common"
import { getLangValue } from "@/utils/common"; //获取后端语言
const PageHeaderT = getLangValue("menu", "my.product-line")
const PageHeaderItems = [
    // {
    //     text: i18n.global.t("menu.my"),
    //     active: false,
    // },
    {
        text: getLangValue("menu", "my.product-line"),
        active: true,
    },
]
const pl_detailRef = ref(null)
const tableRef = ref(null)
const searchData = ref({
    keyword: '',
    template_name: '',
    hscode: '',
})
// const databaseList = ref([])
const hscodeList = ref([])
const hscodeList1 = ref([])


const getTemplateMenu = async () => {
    // let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    let data = []
    if (data.length == 0) {
        const resp = await getProductTemplateMenu()
        if (resp.code == 0) {
            hscodeList.value = resp.payload
        }
    } else {
        hscodeList.value = data
    }
}
const getHscodeList = async () => {

    const resp = await getHscode()
    if (resp.code == 0) {
        hscodeList1.value = resp.payload
    }
}
// const getDatasBaseList = async () => {
//     /**获取所有的数据库list */
//     let x = true
//     if (x) {
//         const resp = await database_template_name_v3()
//         if (resp.code == 0) {
//             databaseList.value = resp.payload
//             getHscodeList();
//         }
//     }
// }
const addClick = () => {
    // console.log('addClick')
    pl_detailRef.value.formData = {
        id: '',
        template_name: '',
        place_of_origin: '',
        HScode: '',
        product_line_no: '',
        product_line_name: '',
        product_line_name_en: '',
        style: [],
        pattern: [],
    }
    pl_detailRef.value.formType = 'add'
    document.getElementById('myBtnPL').click()
    pl_detailRef.value.get_user_company_address()
}
// const getDataBaseTemplateId = (info) => {
//     console.log(hscodeList.value);
//     let arr = hscodeList.value.filter(item => item.name === info.template_name)
//     if (arr.length && arr[0].list) {
//         let arr1 = arr[0].list.filter(item1 => item1.hscode.id == info.hscode.id)
//         if (arr1.length) return arr1[0].id
//     }
//     return ''
// }

// const getDataBaseTemplateId1 = (info) => {
//     let arr = hscodeList.value.filter(item => item.name === info.template_name)
//     if (arr.length && arr[0].list) {
//         let arr1 = arr[0].list.filter(item1 => item1.hscode.id == info.hscode.id)
//         if (arr1.length) return arr1[0].id
//     }
//     return ''
// }

const getDetail = async (info, type) => {
    //获取数据
    // let arr = info.hscode && info.hscode.id ? getParentTree(info.hscode.id, hscodeList.value) : []
    pl_detailRef.value.formData.template_name = i18n.global.locale == 'en' ? info.database_template?.name_en : info.database_template?.name;

    pl_detailRef.value.formData.place_of_origin = info.place_of_origin.id;
    // 如果管理员查看别人的生产地址是看不到的 所以这里要增加一个字符串的显示  地址列表没有信息就显示这个字符串 
    pl_detailRef.value.formData.place_of_origin_str = info.place_of_origin ?
        `${info.place_of_origin.place_of_origin_number}${info.place_of_origin.country}-${info.place_of_origin.province}-${info.place_of_origin.city}-${info.place_of_origin.address1}`
        :
        '';
    pl_detailRef.value.formData.production_line_name = info.production_line_name
    pl_detailRef.value.formData.production_line_name_en = info.production_line_name_en || info.production_line_name
    pl_detailRef.value.formData.production_line_number = info.production_line_number
    // pl_detailRef.value.formData.HScode = info.hscode.id
    // pl_detailRef.value.formData.HScode = getDataBaseTemplateId(info)
    // pl_detailRef.value.changeHscode()
    pl_detailRef.value.hscode = info.database_template.id; // muban id
    pl_detailRef.value.formData.destination_market = info.database_template && info.database_template.status !== 0 && info.database_template.destination_market ? info.database_template.destination_market.id : ''
    // 切换
    pl_detailRef.value.formType = type == 0 ? 'view' : 'edit'
    pl_detailRef.value.formData.id = info.id
    pl_detailRef.value.changTemplate()
    // pl_detailRef.value.getHscdeAndDestination_market(info)
    // console.log(pl_detailRef.value.formData.HScode);
    // console.log(type);
    // 显示图片
    if (info.style.length) {
        let ids = info.style.join(',')
        getFileUrl({ attachments: ids }).then(resp => {
            if (resp) {
                resp.payload.forEach(element => {
                    element.filname = element.name
                });
                pl_detailRef.value.formData.style = resp.payload
                // console.log(fileList.value);
            }
        })
    } else {
        pl_detailRef.value.formData.style = []
    }

    if (info.pattern.length) {
        let ids = info.pattern.join(',')
        getFileUrl({ attachments: ids }).then(resp => {
            if (resp) {
                resp.payload.forEach(element => {
                    element.filname = element.name
                });
                pl_detailRef.value.formData.pattern = resp.payload
                // console.log(fileList.value);
            }
        })
    } else {
        pl_detailRef.value.formData.pattern = []
    }
}

const editDetail = (info) => {
    // 编辑详情
    getDetail(info, 1)
    //显示弹框
    document.getElementById('myBtnPL').click()
    pl_detailRef.value.get_user_company_address()
}
// 获取fatherid
const closeAndUpdate = () => {
    //关闭弹框
    document.getElementById('cancelBTn').click()
    // document.getElementsByClassName('modal-backdrop')[0].remove('show')
    // 关闭弹框后重新查询
    tableRef.value.getDataList()
}

const viewDetail = (info) => {
    // 查看详情
    getDetail(info, 0)
    //显示弹框
    document.getElementById('myBtnPL').click()
    pl_detailRef.value.get_user_company_address()
}

const search = () => {
    tableRef.value.searchData.template_name = searchData.value.template_name
    tableRef.value.searchData.keyword = searchData.value.keyword
    tableRef.value.searchData.hscode = searchData.value.hscode && searchData.value.hscode != null ? [...searchData.value.hscode] : []
}

const reset = () => {
    searchData.value.keyword = ""
    searchData.value.template_name = ""
    searchData.value.hscode = []
    search()
}

onMounted(() => {
    //getDatasBaseList()
    getHscodeList();
    getTemplateMenu();
})

// watch(searchData, (val) => {
//     tableRef.value.searchData.template_name = val.template_name
//     tableRef.value.searchData.keyword = val.keyword
//     tableRef.value.searchData.hscode = val.hscode && val.hscode != null ? [...val.hscode] : []
// }, { deep: true })
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="bg-white"
            style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 160px);border-radius: 0.25rem;">
            <div class="p-4 d-flex justify-content-between align-items-center"
                style="border-bottom: 1px dashed #E9EBEC; font-size: 16px;font-weight: bold;color: #495057;height: 78px;">
                {{ getLangValue('my.product-line', 'title') }}
                <button v-permit="'my.production-line.add'" type="button" class="btn btn-success me-3" id="addBtn"
                    @click="addClick()" style="min-width: 200px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ getLangValue("my.product-line", "add") }}
                </button>
            </div>

            <div class="px-4 py-2 d-flex align-items-center justify-content-between">
                <!-- 搜索 -->
                <div class="saearch d-flex align-items-center" style="flex: 1;">
                    <div class="form-icon" style="width: 560px;">
                        <input type="text" class="form-control form-control-icon" v-model="searchData.keyword"
                            :placeholder="i18n.global.t('product_line.searchPlaceholder')" />
                        <i class="ri-search-line"></i>
                    </div>
                    <div class="w-10 mx-2 my-select">
                        <el-select style="width: 252px; height: 37.5px;" v-model="searchData.template_name" filterable
                            :placeholder="getLangValue('my.product-line', 'searchPlaceholder1')" size="large" clearable>
                            <el-option v-for="item1 in hscodeList" :key="item1.key"
                                :label="i18n.global.locale == 'en' ? item1.name_en : item1.name" :value="item1.name">
                            </el-option>
                        </el-select>
                    </div>
                    <div class=" my-select">
                        <el-cascader filterable size="large" v-model="searchData.hscode"
                            style="width: 100%;height: 37.5px;" :options="hscodeList1"
                            :props="{ label: i18n.global.locale == 'en' ? 'title_en' : 'title', value: 'title', children: 'children', }"
                            placeholder="HS Code" clearable class="my-el" />
                    </div>
                </div>
                <!-- <button v-permit="'my.production-line.add'" type="button" class="btn btn-success me-3"
                    @click="addClick()" style="min-width: 200px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ getLangValue("my.product-line','add") }}
                </button> -->
                <b-button variant="success" @click="search"
                    style="min-width: 100px; background-color: #405189;display: flex;align-items: center;border-color: unset; justify-content: center; ">
                    <i class="ri-search-line me-1"></i>{{ getLangValue('base.search') }}
                </b-button>
                <b-button class="mx-2" variant="success" @click="reset"
                    style="min-width: 100px;background-color: #299CDB;display: flex;align-items: center; border-color: unset; justify-content: center;">
                    <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
                </b-button>
            </div>
            <!-- 表格 -->
            <div class="" style="height:calc(100% - 130px)">
                <TableCom ref="tableRef" @editDetail="editDetail" @viewDetail="viewDetail" />
            </div>
            <!-- 弹框 -->
            <button type="button" class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#myModal"
                style="display: none;" id="myBtnPL"></button>
            <DetailCom ref="pl_detailRef" :hscodeList="hscodeList" @closeAndUpdate="closeAndUpdate" />
        </div>
    </Layout>
</template>
<style scoped lang="scss">
.my-select {
    :deep(.el-select__wrapper) {
        min-height: 37.5px;
        height: 100% !important;
    }
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>